(function () {
    'use strict';

    angular
        .module('app')
        .factory('selectionService', selectionService);

    selectionService.$inject = ['$http'];

    function selectionService($http) {
        var service = {
            selection: getData
        };

        return service;

        function getData() { }
    }
})();